import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { Button, Modal } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';
import { reopen } from '../../../services/repository/payrollRepository';
import mostrarErro from '../../../services/util/error-handler';
import { ModalStyled } from './ModalStyled';

const TextoModal = styled.p`
  font-size: 12px;
  color: #a3a4a5;
`;

function ModalReaberturaAdmin({ visible = false, onSuccessful, onError, onCancel, payroll = {} }) {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirmClick = async () => {
    try {
      setIsLoading(true);
      await reopen(payroll.id);
      onSuccessful(payroll);

      Modal.success({
        title: 'Sucesso',
        content: (
          <p>
            Pedido reaberto com sucesso, em instantes o gestor responsável receberá um e-mail para reenviar o pedido.
          </p>
        ),
      });
    } catch (err) {
      mostrarErro(err);
      onError(payroll, err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalStyled
      open={visible}
      title="Reabertura"
      closeable={false}
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={handleConfirmClick}
          loading={isLoading}
        >
          <CustomText color="var(--system-bg)">Enviar</CustomText>
        </Button>,
        <Button
          key="back"
          onClick={onCancel}
          disabled={isLoading}
        >
          Cancelar
        </Button>,
      ]}
    >
      <TextoModal>
        Você tem certeza que deseja reabrir a requisição <b>{payroll.id}</b>?
      </TextoModal>
    </ModalStyled>
  );
}

ModalReaberturaAdmin.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSuccessful: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  payroll: PropTypes.shape(),
};

export default ModalReaberturaAdmin;
